import { FeeTierDisplayUnit } from 'src/components/Modals/FeeTierModal/types';
import { useCallback } from 'react';
import useModal from 'src/components/Modals/hooks/useModal';

interface Params {
	setDisplayUnit: (value: FeeTierDisplayUnit) => void;
}

export default function useFeeTierModalHandlers({ setDisplayUnit }: Params) {
	const { hide } = useModal();

	const handleChangeDisplayUnit = useCallback(
		(value: FeeTierDisplayUnit) => {
			setDisplayUnit(value);
		},
		[setDisplayUnit]
	);

	return {
		handleChangeDisplayUnit,
		handleCloseModal: hide,
	};
}
